import { Record } from 'immutable'
import { CUSTOMER_API } from 'constants/ResourcesConstants'
import { PostJsonHeaders, getAuthorizationHeader } from 'utils/Helpers'

export const Bot = Record({
  botId: undefined,
  enabled: false,
  name: "",
  orgId: undefined,
  avatarUrl: undefined,
})

const BotAPI = {
  fetchOrCreate(orgId) {
    return fetch(`${CUSTOMER_API}/organizations/${orgId}/bots`, {
      method: 'GET',
      headers: getAuthorizationHeader(),
    }).then((res) => {
      if (res.ok) {
        return res.json().then(Bot)
      } else {
        if (res.status === 404) {
          return this.create(orgId)
        } else {
          throw new Error(`Failed to fetch bot settings for org ${orgId}: [${res.status}] ${res.statusText}`)
        }
      }
    })
  },

  create(orgId) {
    return fetch(`${CUSTOMER_API}/organizations/${orgId}/bots`, {
      method: 'POST',
      headers: getAuthorizationHeader(),
    }).then((res) => {
      if (res.ok) {
        return res.json().then(Bot)
      } else {
        throw new Error(`Failed to create bot for org ${orgId}`)
      }
    })
  },

  enable(orgId, enabled) {
    return fetch(`${CUSTOMER_API}/organizations/${orgId}/bots`, {
      method: 'PATCH',
      body: JSON.stringify({ enabled }),
      headers: new Headers({
        ...PostJsonHeaders,
        ...getAuthorizationHeader(),
      })
    }).then((res) => {
      if (res.ok) {
        return res.json().then(Bot)
      } else {
        throw new Error(`Failed to set bot for org ${orgId} to ${enabled}: [${res.status}] ${res.statusText}`)
      }
    })
  },
}

export default BotAPI



// WEBPACK FOOTER //
// ./src/scripts/app/api/BotAPI.js